import type { Instance } from "mobx-state-tree";
import { types, flow } from "mobx-state-tree";
import { IssuesStore } from "./pm/IssuesStore";
import { MentionsStore } from "./pm/MentionsStore";
import { NotificationsStore } from "./pm/NotificationsStore";
import { ProjectMembersStore } from "./pm/ProjectMembersStore";
import type { Discipline } from "@/domains/pm/types";
import * as pmRepo from "./pm/repository";

export const PMStore = types
  .model("PMStore", {
    /** Domain store: Issue tracking and kanban */
    issues: types.optional(IssuesStore, {}),
    /** WHA-3339: per-building unread @-mention count for the nav dot */
    mentions: types.optional(MentionsStore, {}),
    /** WHA-3733: per-building unread issue-activity count for the Notifications nav dot */
    notifications: types.optional(NotificationsStore, {}),
    /** WHA-3507: per-project cache of users assignable to issues and
     *  available for @-mention on each project. */
    projectMembers: types.optional(ProjectMembersStore, {}),
  })
  .volatile(() => ({
    disciplines: [] as Discipline[],
    disciplinesLoaded: false,
  }))
  .actions((self) => ({
    loadDisciplines: flow(function* loadDisciplines() {
      if (self.disciplinesLoaded) return;
      const disciplines: Discipline[] = yield pmRepo.listDisciplines();
      self.disciplines = disciplines;
      self.disciplinesLoaded = true;
    }),
  }));

export type PMStoreInstance = Instance<typeof PMStore>;
